import { render } from "./index.vue?vue&type=template&id=674e1138&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=674e1138&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674e1138"]])

export default __exports__